import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["trigger"];
  static values = {
    path: String,
  };

  triggerTargetConnected() {
    console.log(
      "triggerTargetConnected",
      this.triggerTarget.dataset,
      this.triggerTarget.dataset.reloadAt,
    );
    this.checkAndScheduleReload();
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  checkAndScheduleReload() {
    const targetTime = this.triggerTarget.dataset.reloadAt;
    if (!targetTime) return;
    const now = Math.floor(Date.now() / 1000);

    if (now >= targetTime) {
      this.reload();
    } else {
      const delay = (targetTime - now) * 1000;
      this.timeout = setTimeout(() => {
        this.reload();
      }, delay);
    }
  }

  reload() {
    this.element.src = this.pathValue;
  }
}
